import { render, staticRenderFns } from "./CalloutCards.vue?vue&type=template&id=5099a4b0"
import script from "./CalloutCards.vue?vue&type=script&lang=js"
export * from "./CalloutCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports